import type { RecipeCategory } from '../types';

export const RECIPE_CATEGORIES: readonly RecipeCategory[] = [
    'General',
    'First',
    'Meal',
    'Side',
    'Dessert',
    'Spread',
    'Snack',
];

/** Display / grouping order for meal menus and pickers. */
export const RECIPE_CATEGORY_ORDER: readonly RecipeCategory[] = [
    'First',
    'Meal',
    'Side',
    'Snack',
    'Spread',
    'Dessert',
    'General',
];

export const FIRST_COURSE_KEYWORDS = [
    'first course',
    'starter',
    'appetizer',
    'appetiser',
    'opening course',
    'ראשונה',
    'מנה ראשונה',
    'מנת פתיחה',
    'פתיח',
    'פתיחה',
    'מנת ראשונה',
];

export function isRecipeCategory(value: string): value is RecipeCategory {
    return (RECIPE_CATEGORIES as readonly string[]).includes(value);
}

export function getRecipeCategoryTranslationKey(category: RecipeCategory): string {
    return category.toLowerCase();
}
